import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";

export default function MainLayout(props) {
  const { sidebar, children } = props;
  return (
    <main className="container-fluid">
      <Row className="mt-3">
        <Col xs="12" md={{ size: 8, push: 4 }}>
          {children}
        </Col>
        <Col xs="12" md={{ size: 4, pull: 8 }}>
          {sidebar}
        </Col>
      </Row>
    </main>
  );
}

MainLayout.propTypes = {
  sidebar: PropTypes.node,
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/Layout/MainLayout.js